__webpack_require__.p = "/dev/add-piece/";